module.exports = __webpack_public_path__ + "img/1721267686362-WhatsApp Image 2024-07-18 at 09.54.06.jpeg.da6fde0d.webp";